"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_base_1 = require("native-base");
const react_1 = require("react");
const colors_1 = require("../../common/colors");
const VStack_1 = __importDefault(require("../ui-components/VStack"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../common/constants");
const AppInput = ({ children, onReset, ...rest }) => {
    const selectedFontId = (0, react_redux_1.useSelector)((state) => state.fontSettings.selectedFontId);
    const selectedFont = constants_1.AVAILABLE_FONTS.find(font => font.id === selectedFontId);
    const fontFamily = selectedFont?.fontFamily || 'system font';
    const defaultStyle = (0, react_1.useMemo)(() => {
        return {
            backgroundColor: colors_1.Colors.DARK_600,
            color: rest?.value ? colors_1.Colors.white : colors_1.Colors.DARK_300,
            fontFamily: fontFamily,
        };
    }, [rest?.value, fontFamily]);
    // Style for rightElement & Left element stack
    const defaultStackStyle = (0, react_1.useMemo)(() => {
        return {
            bg: colors_1.Colors.DARK_600,
        };
    }, [rest?.value]);
    const defaultFocusStyle = (0, react_1.useMemo)(() => {
        return {
            style: {
                color: colors_1.Colors.white,
                fontFamily: fontFamily,
            },
            selectionColor: colors_1.Colors.white,
            placeholderTextColor: colors_1.Colors.white,
            _stack: {
                background: colors_1.Colors.PRIMARY_700,
            },
        };
    }, [rest?.value, fontFamily]);
    const inputElement = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(native_base_1.Input, { allowFontScaling: false, variant: "rounded", style: defaultStyle, fontFamily: fontFamily, _focus: { ...defaultFocusStyle, style: [rest.style, defaultFocusStyle.style] }, _stack: defaultStackStyle, ref: inputElement, borderWidth: 1, borderColor: colors_1.Colors.DARK_500, focusOutlineColor: colors_1.Colors.DARK_500, borderRadius: 8, autoCorrect: false, InputRightElement: rest?.value ? ((0, jsx_runtime_1.jsx)(VStack_1.default, { alignContent: "center", justifyContent: "center", padding: 2, children: onReset && ((0, jsx_runtime_1.jsx)(native_base_1.Pressable, { onPress: () => {
                        onReset?.();
                    }, style: {
                        padding: 5,
                    }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircleXmark, size: 20, color: colors_1.Colors.white }) })) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), ...rest, children: children }) }));
};
exports.AppInput = AppInput;
